import { AUTHENTICATED_HOME_ROUTE, createFileRoute, redirect } from '../../utils';

const Home = () => <div />;

export const Route = createFileRoute('/app/')({
  beforeLoad: () => {
    throw redirect({ to: AUTHENTICATED_HOME_ROUTE });
  },
  component: Home,
});
